import axios from 'axios'
//import { LayoutDetails } from '#components'


export default {
  methods: {
    resolveComponent (type) {
      return defineAsyncComponent(() => import(`~/components/modals/${type}.vue`))
    },
    toggleEditMode () {
      this.showRightSideMenu = false
      if (this.$store.state.editMode) {
        this.showMenu = false
      }
      this.$store.dispatch('toggleEditMode')
    },
    exitEditMode () {
      if (!this.$store.state.editMode) {
        return
      }
      this.showRightSideMenu = false
      this.showMenu = false
      this.$store.commit('setEditMode', false)
    },
    openUiFeatures () {
      this.exitEditMode()
      this.EventBus.$emit('showComponent', {
        shopId: this.shopId,
        component: 'UiFeatureCatalog',
        title: this._('Ready-made screens')
      })
    },
    toggleMenu () {
      this.showMenu = !this.showMenu
    },
    openMenu () {
      this.showMenu = true
    },
    closeMenu () {
      this.showMenu = false
      this.showRightSideMenu = false
    },
    editLayout (layout) {
      const LayoutDetails = this.resolveComponent('ModalLayoutDetails')
      this.showModal('layoutdetails', LayoutDetails, {
        props: {
          baseDomain: this.baseDomain,
          shopId: this.shopId,
          apiKey: this.apiKey,
          component: {
            initData: {
              layoutId: layout.id,
              modal: true
            }
          }
        },
        events: {
          unlinkLayout: this.unlinkLayout
        },
        handlers: {},
        width: 1000
      })
    },
    async addLayout () {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/clients/' + this.clientid + '.json')
      } catch(e) {
        return
      }
      let client = response.data
      const LayoutSelector = this.resolveComponent('LayoutSelector')
      this.showModal('layoutselector', LayoutSelector, {
        props: {
          selectedLayouts: client.sharedLayout
        },
        events: {
          selectLayout: this.selectLayout,
          openUiFeatures: this.openUiFeatures
        },
        handlers: {},
        width: 800
      })
    },
    async saveLayout (data) {
      try {
        let url = this.baseDomain + this.shopId + '/layouts/' + data.id + '.json?apikey=' + this.apiKey
        await axios.put(url, data)
      } catch (e) {
        console.log(e)
      }
    },
    async selectLayout (id) {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/clients/' + this.clientid + '.json')
      } catch(e) {
        return
      }
      let client = response.data
      try {
        let url = this.baseDomain + this.shopId + '/clients/' + client.id + '.json?apikey=' + this.apiKey
        let data = {
          id: client.id,
          layout_id: id
        }
        await axios.patch(url, data)
      } catch(e) {
        console.log(e)
      }
    },
    async unlinkLayout (id) {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/clients/' + this.clientid + '.json')
      } catch(e) {
        return
      }
      let client = response.data
      try {
        let url = this.baseDomain + this.shopId + '/clients/' + client.id + '.json?apikey=' + this.apiKey
        let data = {
          id: client.id,
          layout_id: id,
          action: 'unlink'
        }
        await axios.patch(url, data)
      } catch(e) {
        console.log(e)
      }
    },
    async layoutOrderChanged () {
      const data = {
        id: null,
        layout: null,
        layouts: null
      }
      const layouts = []
      for (let i = 0; i < this.myLayouts.length; i++) {
        const ml = this.myLayouts[i]
        if (i === 0) {
          data.layout = ml.id
        } else if (parseInt(ml.id)) {
          layouts.push(ml.id)
        }
      }
      data.layouts = layouts.join(';')
      // The non-editmode layout-strip is rendered from the store's `layouts`
      // getter (via the `visibleLayouts` computed), while the draggable
      // editmode strip is rendered from local `myLayouts`. Without updating
      // the store here too, leaving edit mode would flip the strip back to
      // the stale, pre-reorder order until the next full reload.
      this.updateLayoutsOrder(this.myLayouts.filter(ml => ml.id !== 'add').map(ml => ml.id))
      // Saving triggers a realtime "clientUpdate" echo back to this same session.
      // Guard against it so a reloadClient() doesn't race with the in-progress/just
      // finished drag-and-drop reorder and corrupt the local layout list.
      this.layoutReorderGuardUntil = Date.now() + 5000
      this.reorderLayouts(data)
    },
    updateLayoutsOrder (orderedIds) {
      if (!this.layouts || !this.layouts.length) {
        return
      }
      const byId = new Map(this.layouts.map(l => [String(l.id), l]))
      const queue = orderedIds.map(id => byId.get(String(id))).filter(Boolean)
      let queueIndex = 0
      // Only reshuffle the visible/orderable layouts, leaving hidden/settings
      // layouts in their existing slot so we don't disturb any other logic
      // that may rely on their position within the array.
      const reordered = this.layouts.map(l => {
        if (l.hidden || l.isSettings) {
          return l
        }
        const next = queue[queueIndex]
        queueIndex += 1
        return next || l
      })
      this.$store.dispatch('setLayouts', reordered)
    },
    async reorderLayouts (data) {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/clients/' + this.clientid + '.json')
      } catch(e) {
        return
      }
      let client = response.data
      try {
        let url = this.baseDomain + this.shopId + '/clients/' + client.id + '.json?apikey=' + this.apiKey
        data.id = client.id
        await axios.put(url, data)
      } catch(e) {
        console.log(e)
      }
    }
  }
}